/**
 * Converts total minutes into hours and minutes.
 * @param {number} totalMinutes - Total minutes to convert.
 * @returns {string} - Formatted string, e.g., "1 hr 30 min".
 */
export const formatDuration = (totalMinutes) => {
  if (totalMinutes <= 0) return "0 min";

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const hoursText = hours > 0 ? `${hours} hr${hours > 1 ? "s" : ""}` : "";
  const minutesText = minutes > 0 ? `${minutes} min` : "";

  return [hoursText, minutesText].filter(Boolean).join(" ");
};